// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1NcoT","select":"Header_select__3BLrn","clinic":"Header_clinic__3TS6L"};